/*
 * Copyright (c) 2018-2019 by Felix Heim, felix.heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('CrewController', CrewController);

    CrewController.$inject = ['$http', 'entity', 'Crew', '$scope', '$window', 'AlertService', 'viewParams'];

    function CrewController($http, entity, Crew, $scope, $window, AlertService, $viewParams) {
        var vm = this;
        vm.project = entity;
        vm.type = $viewParams.type;
        vm.goTo = goTo;
        vm.createNew = createNew;
        vm.deleteCrew = deleteCrew;
        vm.deleteFromCrew = deleteFromCrew;
        vm.insertedInCrew = insertedInCrew;
        vm.deleteFromWithoutCrew = deleteFromWithoutCrew;
        vm.insertedIntoWithout = insertedIntoWithout;
        vm.dataExport = dataExport;
        vm.saveNausys = saveNausys;
        vm.exportToOnlineCrewlist = exportToOnlineCrewlist;

        vm.isCollapsed = false;
        vm.toggleAccordion = toggleAccordion;

        getCrews();
        getBookingsWithoutCrew();

        function getCrews() {
            vm.isSaving = true;
            $http.get('api/crews', {
                params: {
                    projectId: entity.id
                }
            }).then(function (response) {
                vm.crews = response.data;
                for(var i = 0; i < vm.crews.length; i++) {
                    vm.crews[i].isCollapsed = false;
                }
                vm.isSaving = false;
            });
        }

        function getBookingsWithoutCrew() {
            $http.get('api/crews/bookings', {
                params: {
                    projectId: entity.id
                }
            }).then(function (response) {
                vm.bookingsWithoutCrew = response.data;
            });
        }

        function goTo(url) {
            if (vm.type === 'nausys') {
                $window.open("https://crew.nausys.com/" + url + "/", "_blank");
            } else if (vm.type === 'bm'){
                $window.open("https://www.booking-manager.com/cbm/servlet/cbm?" + url, "_blank");
            }
        }

        function createNew() {
            vm.isSaving = true;
            $http.post('api/crews', {
                id: null,
                project: entity
            }).then(function (response) {
                vm.isSaving = false;
                var newCrew = response.data;
                newCrew.members = [];
                newCrew.isCollapsed = false;
                vm.crews.push(newCrew);
            });
        }

        function deleteCrew(id, index) {
            vm.crews.splice(index, 1);
            Crew.delete({id: id});
        }

        function deleteFromCrew(index, crewIndex) {
            // fires after insert
            vm.crews[crewIndex].members.splice(index, 1);
        }

        function insertedInCrew(index, crewIndex) {
            var crew = vm.crews[crewIndex];
            Crew.update(crew, function (response) {
                vm.crews[crewIndex] = response;
            });
        }

        function deleteFromWithoutCrew(member) {
            vm.bookingsWithoutCrew.splice(vm.bookingsWithoutCrew.indexOf(member), 1);
        }

        function insertedIntoWithout(index) {
            Crew.update({
                id: null,
                project: entity.id,
                members: [vm.bookingsWithoutCrew[index]]
            });
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/crews/export/', {
                params: {
                    projectId: entity.id
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }

        $scope.dragoverCallback = function (event, index, external, type) {
            //console.log(event.path[1]);
            //var ul = event.path[1];
            //$(ul).find('.dndPlaceholder2').hide();

            return true;
        };

        function saveNausys(crew) {
            vm.isSaving = true;
            var crewCopy = angular.copy(crew);
            crewCopy.members = [];
            $http.post('api/crews/nausys/', crewCopy).then(function (response) {
                vm.error = null;
                vm.isSaving = false;
            }, function (error) {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }

        function exportToOnlineCrewlist(crew) {
            vm.isSaving = true;
            $http.get('api/crews/' + vm.type + '/export/', {
                params: {
                    crewId: crew.id
                }
            }).then(function (response) {
                vm.error = null;
                vm.isSaving = false;
            }).catch(function (error) {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }

        function toggleAccordion() {
            vm.isCollapsed = !vm.isCollapsed;
            for(var i = 0; i < vm.crews.length; i++) {
                vm.crews[i].isCollapsed = vm.isCollapsed;
            }
        }
    }
})();
